import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { ExperimentsList } from './experiments-list';
import { ExperimentDetails } from './experiment-details/experiment-details';

export const ExperimentsOutlet: React.FunctionComponent = () => {
    return (
        <Routes>
            <Route path="" element={<ExperimentsList />} />
            <Route path=":experimentId" element={<ExperimentDetails />} />
        </Routes>
    );
};

